// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gg-sale-grid[data-v-118c4846]{max-width:1486px;margin:0 auto}.gg-sale-grid__second-row[data-v-118c4846]{margin-top:15px}@media (max-width:800px){.gg-sale-grid__second-row[data-v-118c4846]{margin-top:5px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
